export default from './post-page-footer-wrapper';



// WEBPACK FOOTER //
// ./app/components/post-page-footer-wrapper/index.js